import { GA_VERSIONS } from "../constants";

class GoogleanAlytics {
  constructor(context) {
    this.context = context;
    this.axios = this.context.$axios;
  }

  async getAnalytics(
    product,
    businessUnitId,
    startDate,
    endDate,
    version = GA_VERSIONS.GA4
  ) {
    try {
      const googleAnalitics = await this.axios.get(
        `${process.env.VUE_APP_API_BASE_URL_ANALYTIC}/gan-pageviews?bookCode=${product}&countryId=${businessUnitId}&startDate=${startDate}&endDate=${endDate}&version=${version}`
      );
      return googleAnalitics.data;
    } catch (err) {
      console.log(err);
    }
  }

  async getSearchs(bookCode) {
    const id = localStorage.getItem("businessUnitId");

    try {
      const searchs = await this.axios.get(
        `${
          process.env.VUE_APP_API_BASE_URL
        }/portal-stats/${1}/businesses/${id}/takealook?bookCode=${bookCode}`
      );
      return searchs.data;
    } catch (err) {
      console.log(err);
    }
  }
}

export default GoogleanAlytics;
